// src/pages/BranchTransferReceiveList/components/exportBranchTransferReceiveCsv.js
import dayjs from "dayjs";

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

const fmtDate = (val) => (val ? dayjs(val).format("DD-MM-YYYY") : "-");
const fmtNum  = (val) => Number(val || 0).toFixed(2);

/**
 * @param {object} params
 * @param {Array}   params.list     - from Redux state.branchTransferReceive.list
 * @param {object}  params.filters  - for recordType check
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportBranchTransferReceiveCsv = ({
  list,
  filters,
  title    = "Branch Transaction Received List",
  filename = "branch_transfer_receive",
}) => {
  const isWithDetails = filters?.recordType === "with details";

  let headers;
  let buildRow;

  if (isWithDetails) {
    headers = [
      "No.", "Voucher", "Date", "Customer",
      "Receipt By", "Receipt Into", "Receipt Amount",
    ];
    buildRow = (row, i) => [
      i + 1,
      row.con_code                          || "",
      fmtDate(row.tran_date),
      row.acc_name                          || "",
      row.full_name                         || "",
      row.details?.[0]?.into_acc_name       || "",
      fmtNum(row.details?.[0]?.con_total),
    ];
  } else {
    headers = [
      "No.", "Date", "Branch Name", "From Account",
      "To Account", "Tran By", "Amount",
    ];
    buildRow = (row, i) => [
      i + 1,
      fmtDate(row.tran_date),
      row.name          || "",
      row.from_acc_name || "",
      row.to_acc_name   || "",
      row.full_name     || "",
      fmtNum(row.tran_amount),
    ];
  }

  const grandTotal = list.reduce((s, r) => {
    if (isWithDetails) return s + Number(r.con_total || 0);
    return s + Number(r.tran_amount || 0);
  }, 0);

  const totalRow = [
    "Grand Total:",
    ...Array(headers.length - 2).fill(""),
    fmtNum(grandTotal),
  ];

  const rows = [
    [title],
    [],
    headers.map(escape),
    ...list.map((row, i) => buildRow(row, i).map(escape)),
    [],
    totalRow.map(escape),
  ];

  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};